import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CursorStyles from './styles'; // Path to your CursorStyles.js file


const Cursor = () => {
  const [top, setTop] = useState(0);
  const [left, setLeft] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setTop(e.pageY);
      setLeft(e.pageX);
      };


    const handleMouseEnter = () => {
      setIsActive(true);
      };

    const handleMouseLeave = () => {
      setIsActive(false);
    };

    const handleClick = () => {
      setIsActive(false);
    };

    document.querySelectorAll('a').forEach((link) => {
      link.addEventListener('mouseenter', handleMouseEnter);
      link.addEventListener('mouseleave', handleMouseLeave);
      link.addEventListener('click', handleClick);
    });

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.querySelectorAll('a').forEach((link) => {
        link.removeEventListener('mouseenter', handleMouseEnter);
        link.removeEventListener('mouseleave', handleMouseLeave);
        link.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <>
  <Box
    sx={{
      ...CursorStyles.cursor1,
      ...(isActive && CursorStyles.cursor1['&.active']),
      top: `${top}px`,
      left: `${left}px`
    }}
  />
  <Box
    sx={{
      ...CursorStyles.cursor2,
      ...(isActive && CursorStyles.cursor2['&.active']),
      top: `${top}px`,
      left: `${left}px`
    }}
  />
</>
  );
};

export default Cursor;
